// extracted by mini-css-extract-plugin
export var lg = "_kt-7";
export var md = "_kt-6";
export var placeholderContainer = "_kt-1";
export var placeholderIcon = "_kt-2";
export var productImage = "_kt-0";
export var sm = "_kt-5";
export var xl = "_kt-8";
export var xs = "_kt-4";
export var xxs = "_kt-3";